import styled from '@emotion/styled';
import { colors } from '../../constants/colors';

export const PanelContainer = styled('div')({
  width: '100%',
  backgroundColor: colors.SPINDLE,
  borderRadius: 8,
  padding: 20,
});
